import { render, staticRenderFns } from "./roleDescriptions.vue?vue&type=template&id=0ed12dc0"
import script from "./roleDescriptions.vue?vue&type=script&lang=js"
export * from "./roleDescriptions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports